const approvalStatuses = {
	PENDING: "pending",
	APPROVED: "approved",
	DENIED: "denied",
};

export default approvalStatuses;
